// extracted by mini-css-extract-plugin
export var measureBox = "_15-0";